import { useState, createContext } from "react";
import { TopDisplay } from "../../../ui-components";
import css from "../Approvals/css/approvals.module.css";
import Modal from "../Approvals/Modal";
import DisplayAppplications from "./DisplayApplications";

export const ApplicationsContext = createContext<any>({});

function Applications() {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalView, setModalView] = useState<any>("view");
  const [modalData, setModalData] = useState<any>(null);
  const [routeName, setRouteName] = useState("Examination / NYSC");
  const isApplicationMenu = true;
  const ApplicationsContextProvider = {
    setShowModal,
    setModalView,
    setModalData,
    setRouteName,
    routeName,
    isApplicationMenu,
  };

  return (
    <>
      <ApplicationsContext.Provider value={ApplicationsContextProvider}>
        <div className={css.container}>
          <TopDisplay title="Applications" />
          <DisplayAppplications id="1" />
        </div>
        {/* subTitle={routeName}  */}
        
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          modalView={modalView}
          data={modalData}
        />
      </ApplicationsContext.Provider>
    </>
  );
}

export default Applications;
